import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { ModalNavigationComponent } from '../../../../services/gui/modal/modal-navigation-component';
import { API, DeviceFullDTO } from '../../../../services/api/api';
import { ModalNavigationService } from '../../../../services/gui/modal/modal-navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService, ToastType } from '../../../../services/toaster/toaster.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sb-device-playlist-cache',
  templateUrl: './sb-device-playlist-cache.component.html',
  styleUrls: ['./sb-device-playlist-cache.component.scss'],
  standalone: false,
})
export class SbDevicePlaylistCache implements OnInit, ModalNavigationComponent {
  private readonly destroyRef = inject(DestroyRef);
  isInModalContext: boolean;

  @Input() device: DeviceFullDTO;

  constructor(
    public api: API,
    public modalNavigation: ModalNavigationService,
    public translate: TranslateService,
    public toaster: ToasterService
  ) {}

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.device = this.modalNavigation.getCurrentNavigation().data.device;
    }
  }

  submit() {
    this.api
      .ss_nm_Device_deleteDevicePlaylistCache(this.device.id)
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe({
        next: () => {
          this.toaster.toast(ToastType.SUCCESS, this.translate.instant('lang.globals.successful'));
        },
        error: () => {
          this.toaster.toast(ToastType.DANGER, this.translate.instant('lang.globals.error'));
        },
      });
    this.goBack();
  }

  reject() {
    this.goBack();
  }

  goBack() {
    this.modalNavigation.goBack();
  }
}
